import { render, staticRenderFns } from "./notification-worker.vue?vue&type=template&id=13bf97bc"
import script from "./notification-worker.vue?vue&type=script&lang=js"
export * from "./notification-worker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports